import { property } from "lit/decorators.js";
import { ShadowlessLitElement } from "@/components/meta/shadowless_lit_element";

export type QuestionConfig = { id: string; type: string } & Record<string, unknown>;

export abstract class QuestionBase extends ShadowlessLitElement {
    @property({ type: String, attribute: "data-config" })
    encodedConfig = "";

    @property({ type: String })
    value = "";

    config!: QuestionConfig;

    override connectedCallback(): void {
        super.connectedCallback();
        this.config = JSON.parse(atob(this.encodedConfig));
    }

    protected setValue(value: string): void {
        this.value = value;
        this.dispatchEvent(new CustomEvent("update", { detail: { value }, composed: true }));
    }
}
